<template>
   <bk-page class="updateAddressPage" pageType="navPage" :navBarInfo="navBarInfo">
		<bk-view class="view-container">
			
			<bk-view class="view-use-currentLocation" @click="handleSetLocInfo">
				<bk-view class="view-icon"></bk-view>
				<bk-lang code="userInfo_updateAddress_currentLocation"></bk-lang>
			</bk-view>

			<bk-view class="view-form-main">
				<bk-form ref="bkForm" v-model="formData" :formConfig="formConfig" >
					<template #slot-countryName="{ row, column}">
						<bk-field-region
							type="country"
							v-bind="column"
							v-model:code="row.countryCode"
							v-model:id="row.countryId"
							v-model:name="row.countryName"
						/>
					</template>
					<template #slot-provinceName="{ row, column}">
						<bk-field-region
							type="province"
							:provinceId="row.countryId"
							v-model:code="row.provinceCode"
							v-model:name="row.provinceName"
							v-bind="column"
						/>
					</template>
				</bk-form>
			</bk-view>
		</bk-view>
		
		<bk-view class="view-footer-main">
			<bk-button size="full" langCode="userInfo_personal_save" @click="handleSave"></bk-button>
		</bk-view>

	</bk-page>
</template>

<script>
	import { showToast } from 'vant';
	import { authReq, baseReq } from '@/reqService';

	export default {
		name:'updateAddress',
		props:{
			curRows:Object
		},
		data (){
			return {
				showPage:'',
				formData:{},
				userInfo:this.$bk_getUserInfo(),
				locInfo:null
			};
		},
		computed:{
			navBarInfo (){
				return {
					langCode_title: this.curRows ? 'userInfo_updateAddress_edit' : 'userInfo_updateAddress_add',
					backFlag: true,
				};
			},
			formConfig (){
				return {
					required:true,
					items:[
						{e:'slot', langCode:'userInfo_updateAddress_region', key:'countryName' },
						{e:'slot', langCode:'userInfo_updateAddress_province', key:'provinceName' },
						{e:'input', langCode:'userInfo_updateAddress_district', key:'cityName' },
						{e:'input', langCode:'userInfo_updateAddress_postalCode', key:'postalCode' },
						{e:'input', langCode:'userInfo_updateAddress_address', key:'address' },
					]
				};
			}
		},
		created (){
			window.getCurrentPosition({
				callback: (e) => {
					console.log('定位结果：', e);

					if (e.success) {
						this.locInfo = e.locInfo || {
							lat: 31,
							lng: 121,
						};
					} else {
						this.locInfo = {
							lat: 31,
							lng: 121,
						};
					}            
				}
			});
		},
		mounted (){
			if(this.curRows){
				this.formData = {...this.curRows};
				this.requestGetRegion();
			}
		},
		methods:{
			async requestGetRegion (id){
				const res = await baseReq.requestGetRegion(this, id);
				
				const current = res.find((item) => {
					return 	this.formData.countryCode === item.code;
				});

				if(current){
					this.formData.countryId = current.id;
				}
			},
			handleSetLocInfo (){
				if(!this.locInfo){
					showToast(this.$bk_lang['userInfo_updateAddress_error']);
					return false;
				}

				const { country, province, district, address} = this.locInfo;

				this.formData.countryName = country;
				this.formData.provinceName = province;
				this.formData.cityName = district;
				this.formData.address = address;
			},
			// 处理提交参数
			getSubmitParams (){
				const params = {
					userId:this.userInfo.userId,
					// lat: 31,
					// lng: 121,
					...this.formData, 
				};

				if(this.locInfo){
					params.lng = this.locInfo.lng;
					params.lat = this.locInfo.lat;
				}
			
				return params;
			},
		
			// 提交
			async handleSave (){

				if(!await this.$refs.bkForm.validator()){
					return false;
				}
				
				const params = this.getSubmitParams();

				this.loading = true;

				let requestFunction =authReq.requestPostAddUserAddress;

				if(this.curRows){
					requestFunction = authReq.requestPostEditUserAddress;
				}
				
				requestFunction(this, params).then(() => {
					this.loading = false;

					this.$emit('reload');
					this.$emit('close');
				}).catch(() => {
					this.loading = false;
				});

			}
		}
	};
</script>

<style lang="less">
@import './updateAddress.less';
</style>